// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"e36c4673","160":"82ca8592","208":"ae67d961","293":"794bfebb","453":"a7d99afe","516":"c384a87b","519":"c11b2054","840":"8e003e06","917":"3c481def","946":"810cb885"}[chunkId] + ".chunk.js";
};